import { Component,OnInit } from '@angular/core';
import { PageService } from './page.service';
import { PageItem } from './page';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'industria-paisaia';
  public pages : PageItem[];

  constructor (
    private pageService : PageService
  ) {}

  ngOnInit() {
    // this.pageService.getItems();
    this.pageService.getParentPages()
      .subscribe(data => {
        this.pages = data;
      });
  }

}
